import { Maybe } from '@pylot-data/fwrdschema'
import dynamic from 'next/dynamic'
import type { Dispatch, SetStateAction } from 'react'

type RichContentProps = {
    classes?: {
        root: string
    }
    html?: Maybe<string>
    extend?: boolean
    config?: any
    isLazyLoad?: boolean
    ProductTile?: React.ElementType
    productQuery?: string
    extendedContentTypeConfig?: any
    isMenu?: boolean
    setOpened?: Dispatch<SetStateAction<string>>
}

export const AlfaRichContent = dynamic<RichContentProps>(
    () => import('./src/richContent')
)
